/**
 * @packageDocumentation
 * @module HackerAPI.Event.Application
 */
import { __extends } from "tslib";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
import Base from "../../base/base";
import { parseNumber, parseArray, parseString, parseArrayOrNull, parseStringOrNull, parseBoolean } from "../../utils/utils";
/**
 * A data container for a hacker application
 * @class
 * @extends { HackerAPI.Base }
 */
var Application = /** @class */ (function (_super) {
    __extends(Application, _super);
    /**
     * Creates a new Application object
     * @constructor
     * @param application
     */
    function Application(_a) {
        var id = _a.id, name = _a.name, email = _a.email, stage = _a.stage, level_of_study = _a.level_of_study, levelOfStudy = _a.levelOfStudy, major = _a.major, travel_location = _a.travel_location, travelLocation = _a.travelLocation, links = _a.links, hackathons_attended = _a.hackathons_attended, hackathonsAttended = _a.hackathonsAttended, kind_of_hacker = _a.kind_of_hacker, hackerKinds = _a.hackerKinds, gainFromHackTheNorth = _a.gainFromHackTheNorth, question_gain_from_htn = _a.question_gain_from_htn, hardestChallenge = _a.hardestChallenge, question_hardest_challenge = _a.question_hardest_challenge, question_stressful_team = _a.question_stressful_team, stressfulTeamSituation = _a.stressfulTeamSituation, gender = _a.gender, survey_gender = _a.survey_gender, ethnicities = _a.ethnicities, survey_ethnicity = _a.survey_ethnicity, technologiesUsed = _a.technologiesUsed, survey_tech_used = _a.survey_tech_used, technologyMostExcitedAbout = _a.technologyMostExcitedAbout, survey_tech_most_excited = _a.survey_tech_most_excited, hadHighSchoolTechCourses = _a.hadHighSchoolTechCourses, survey_tech_course_hs = _a.survey_tech_course_hs, yearsBuilding = _a.yearsBuilding, survey_years_building = _a.survey_years_building, familyInTech = _a.familyInTech, survey_family_in_tech = _a.survey_family_in_tech, firstInFamilyToPursuePostSecondary = _a.firstInFamilyToPursuePostSecondary, survey_family_in_higher_ed = _a.survey_family_in_higher_ed, app_goose_colour = _a.app_goose_colour, gooseColor = _a.gooseColor, app_goose_accessory = _a.app_goose_accessory, gooseAccessory = _a.gooseAccessory, latitude = _a.latitude, longitude = _a.longitude, consent_event_org = _a.consent_event_org, dataForOrganizationalPurposes = _a.dataForOrganizationalPurposes, consent_aggregate_report = _a.consent_aggregate_report, dataForReporting = _a.dataForReporting, consent_partners_sponsors = _a.consent_partners_sponsors, dataForSponsors = _a.dataForSponsors, consent_privacy_policy = _a.consent_privacy_policy, consentsToPrivacyPolicy = _a.consentsToPrivacyPolicy, school = _a.school, graduating_year = _a.graduating_year, graduatingYear = _a.graduatingYear, legal_name = _a.legal_name, legalName = _a.legalName, date_of_birth = _a.date_of_birth, dateOfBirth = _a.dateOfBirth, citizenship = _a.citizenship, legal_age = _a.legal_age, isOfLegalAge = _a.isOfLegalAge, parental_consent = _a.parental_consent, parentalConsent = _a.parentalConsent, mlh_opt_in = _a.mlh_opt_in, mlhOptIn = _a.mlhOptIn, emergency_name = _a.emergency_name, emergencyName = _a.emergencyName, emergency_email = _a.emergency_email, emergencyEmail = _a.emergencyEmail, emergency_phone = _a.emergency_phone, emergencyPhone = _a.emergencyPhone, emergency_relation = _a.emergency_relation, emergencyRelation = _a.emergencyRelation, dietary_constraint = _a.dietary_constraint, dietaryConstraints = _a.dietaryConstraints, health_condition = _a.health_condition, healthConditions = _a.healthConditions, medication = _a.medication, shirt_fit = _a.shirt_fit, shirtFit = _a.shirtFit, shirt_size = _a.shirt_size, shirtSize = _a.shirtSize, shirt_accomodation = _a.shirt_accomodation, shirtAccomodation = _a.shirtAccomodation, hardware = _a.hardware, tech_talk_votes = _a.tech_talk_votes, techTalkVotes = _a.techTalkVotes, project_idea = _a.project_idea, projectIdea = _a.projectIdea, project_keywords = _a.project_keywords, projectKeywords = _a.projectKeywords, travel_source_correct = _a.travel_source_correct, travelSourceCorrect = _a.travelSourceCorrect, immigration_acknowledgement = _a.immigration_acknowledgement, immigrationAcknowledgement = _a.immigrationAcknowledgement, requires_visa = _a.requires_visa, requiresVisa = _a.requiresVisa, visa_acknowledgement = _a.visa_acknowledgement, visaAcknowledgement = _a.visaAcknowledgement, receipts = _a.receipts, friday_flight_number = _a.friday_flight_number, fridayFlightNumber = _a.fridayFlightNumber, friday_flight_airline = _a.friday_flight_airline, fridayFlightAirline = _a.fridayFlightAirline, friday_flight_arrival_time = _a.friday_flight_arrival_time, fridayFlightArrivalTime = _a.fridayFlightArrivalTime, sunday_flight_number = _a.sunday_flight_number, sundayFlightNumber = _a.sundayFlightNumber, sunday_flight_airline = _a.sunday_flight_airline, sundayFlightAirline = _a.sundayFlightAirline, sunday_flight_departure_time = _a.sunday_flight_departure_time, sundayFlightDepartureTime = _a.sundayFlightDepartureTime, flight_payment_currency = _a.flight_payment_currency, flightPaymentCurrency = _a.flightPaymentCurrency, flight_payment_amount = _a.flight_payment_amount, flightPaymentAmount = _a.flightPaymentAmount, share_email_consent = _a.share_email_consent, shareEmailConsent = _a.shareEmailConsent, transit_or_driving = _a.transit_or_driving, transitOrDriving = _a.transitOrDriving, visa_tracking_number = _a.visa_tracking_number, visaTrackingNumber = _a.visaTrackingNumber, reimbursement_method = _a.reimbursement_method, reimbursementMethod = _a.reimbursementMethod, reimbursement_name = _a.reimbursement_name, reimbursementName = _a.reimbursementName, reimbursement_address_line_1 = _a.reimbursement_address_line_1, reimbursementAddressLine1 = _a.reimbursementAddressLine1, reimbursement_address_line_2 = _a.reimbursement_address_line_2, reimbursementAddressLine2 = _a.reimbursementAddressLine2, reimbursement_address_line_3 = _a.reimbursement_address_line_3, reimbursementAddressLine3 = _a.reimbursementAddressLine3, reimbursement_wire_currency = _a.reimbursement_wire_currency, reimbursementWireCurrency = _a.reimbursementWireCurrency, reimbursement_wire_bank_name = _a.reimbursement_wire_bank_name, reimbursementWireBankName = _a.reimbursementWireBankName, reimbursement_wire_bank_address_line_1 = _a.reimbursement_wire_bank_address_line_1, reimbursementWireBankAddressLine1 = _a.reimbursementWireBankAddressLine1, reimbursement_wire_bank_address_line_2 = _a.reimbursement_wire_bank_address_line_2, reimbursementWireBankAddressLine2 = _a.reimbursementWireBankAddressLine2, reimbursement_wire_bank_address_line_3 = _a.reimbursement_wire_bank_address_line_3, reimbursementWireBankAddressLine3 = _a.reimbursementWireBankAddressLine3, reimbursement_wire_branch_number = _a.reimbursement_wire_branch_number, reimbursementWireBranchNumber = _a.reimbursementWireBranchNumber, reimbursement_wire_institution_number = _a.reimbursement_wire_institution_number, reimbursementWireInstitutionNumber = _a.reimbursementWireInstitutionNumber, reimbursement_wire_swift_code = _a.reimbursement_wire_swift_code, reimbursementWireSwiftCode = _a.reimbursementWireSwiftCode, reimbursement_wire_iban_number = _a.reimbursement_wire_iban_number, reimbursementWireIbanNumber = _a.reimbursementWireIbanNumber, reimbursement_wire_routing_number = _a.reimbursement_wire_routing_number, reimbursementWireRoutingNumber = _a.reimbursementWireRoutingNumber, reimbursement_wire_account_number = _a.reimbursement_wire_account_number, reimbursementWireAccountNumber = _a.reimbursementWireAccountNumber, reimbursement_wire_other = _a.reimbursement_wire_other, reimbursementWireOther = _a.reimbursementWireOther, reimbursement_visa_number = _a.reimbursement_visa_number, reimbursementVisaNumber = _a.reimbursementVisaNumber, reimbursement_paypal_email = _a.reimbursement_paypal_email, reimbursementPaypalEmail = _a.reimbursementPaypalEmail, reimbursement_xoom_email = _a.reimbursement_xoom_email, reimbursementXoomEmail = _a.reimbursementXoomEmail, reimbursement_acknowledgement = _a.reimbursement_acknowledgement, reimbursementAcknowledgement = _a.reimbursementAcknowledgement, terms_acknowledgement = _a.terms_acknowledgement, termsAcknowledgement = _a.termsAcknowledgement, travel_method = _a.travel_method, travelMethod = _a.travelMethod, flight_and_bus_location = _a.flight_and_bus_location, flightAndBusLocation = _a.flightAndBusLocation, bus_route = _a.bus_route, busRoute = _a.busRoute, flight_reimbursement = _a.flight_reimbursement, flightReimbursement = _a.flightReimbursement, departure_airport = _a.departure_airport, departureAirport = _a.departureAirport, arrival_airport = _a.arrival_airport, arrivalAirport = _a.arrivalAirport, transit_or_driving_reimbursement_deadline = _a.transit_or_driving_reimbursement_deadline, transitOrDrivingReimbursementDeadline = _a.transitOrDrivingReimbursementDeadline, address_line_1 = _a.address_line_1, addressLine1 = _a.addressLine1, address_line_2 = _a.address_line_2, addressLine2 = _a.addressLine2, address_line_3 = _a.address_line_3, addressLine3 = _a.addressLine3, phone_number = _a.phone_number, phoneNumber = _a.phoneNumber, city = _a.city, province = _a.province, country = _a.country, code = _a.code, has_restriction = _a.has_restriction, hasRestriction = _a.hasRestriction, has_health_concerns = _a.has_health_concerns, hasHealthConcerns = _a.hasHealthConcerns, has_medications = _a.has_medications, hasMedications = _a.hasMedications, other = _a.other, seeking_internship = _a.seeking_internship, seekingInternship = _a.seekingInternship, seeking_fulltime = _a.seeking_fulltime, seekingFulltime = _a.seekingFulltime, has_visa = _a.has_visa, hasVisa = _a.hasVisa, resume = _a.resume, coffee_chat_ranking = _a.coffee_chat_ranking, coffeeChatRanking = _a.coffeeChatRanking, coffee_chat_opt_in = _a.coffee_chat_opt_in, coffeeChatOptIn = _a.coffeeChatOptIn, interested_companies = _a.interested_companies, interestedCompanies = _a.interestedCompanies, stage_id = _a.stage_id, stageId = _a.stageId, guardian_name = _a.guardian_name, guardianName = _a.guardianName, guardian_email = _a.guardian_email, guardianEmail = _a.guardianEmail, rsvp_deadline = _a.rsvp_deadline, rsvpDeadline = _a.rsvpDeadline;
        var _this = _super.call(this, {
            hackerKinds: Base.renameHandler("kind_of_hacker"),
            gainFromHackTheNorth: Base.renameHandler("question_gain_from_htn"),
            hardestChallenge: Base.renameHandler("question_hardest_challenge"),
            stressfulTeamSituation: Base.renameHandler("question_stressful_team"),
            gender: Base.renameHandler("survey_gender"),
            ethnicities: Base.renameHandler("survey_ethnicity"),
            technologiesUsed: Base.renameHandler("survey_tech_used"),
            technologyMostExcitedAbout: Base.renameHandler("survey_tech_most_excited"),
            hadHighSchoolTechCourses: Base.renameHandler("survey_tech_course_hs"),
            yearsBuilding: Base.renameHandler("survey_years_building"),
            familyInTech: Base.renameHandler("survey_family_in_tech"),
            firstInFamilyToPursuePostSecondary: Base.renameHandler("survey_family_in_higher_ed"),
            gooseColor: Base.renameHandler("app_goose_colour"),
            gooseAccessory: Base.renameHandler("app_goose_accessory"),
            dataForOrganizationalPurposes: Base.renameHandler("consent_event_org"),
            dataForReporting: Base.renameHandler("consent_aggregate_report"),
            dataForSponsors: Base.renameHandler("consent_partners_sponsors"),
            consentsToPrivacyPolicy: Base.renameHandler("consent_privacy_policy"),
            isOfLegalAge: Base.renameHandler("legal_age"),
            dietaryConstraints: Base.renameHandler("dietary_constraint"),
            healthConditions: Base.renameHandler("health_condition"),
            reimbursementAddressLine1: Base.renameHandler("reimbursement_address_line_1"),
            reimbursementAddressLine2: Base.renameHandler("reimbursement_address_line_2"),
            reimbursementAddressLine3: Base.renameHandler("reimbursement_address_line_3"),
            reimbursementWireBankAddressLine1: Base.renameHandler("reimbursement_wire_bank_address_line_1"),
            reimbursementWireBankAddressLine2: Base.renameHandler("reimbursement_wire_bank_address_line_2"),
            reimbursementWireBankAddressLine3: Base.renameHandler("reimbursement_wire_bank_address_line_3"),
            addressLine1: Base.renameHandler("address_line_1"),
            addressLine2: Base.renameHandler("address_line_2"),
            addressLine3: Base.renameHandler("address_line_3")
        }) || this;
        _this.id = id;
        /**
         * The hacker's name
         * @type { string }
         */
        _this.name = name;
        /**
         * The hacker's email
         * @type { string }
         */
        _this.email = email;
        /**
         * The stage that the hacker's application is in
         * @type { "not_accepted" | "accepted" | "withdrawn" | "expired" | "auto-accepted" | "confirmed" | "checked_in" }
         */
        _this.stage = stage;
        /**
         * The hacker's level of study
         * @type { string }
         */
        _this.levelOfStudy = level_of_study || levelOfStudy;
        /**
         * The hacker's major
         * @type { string }
         */
        _this.major = major;
        /**
         * Where the hacker is travelling from
         * @type { string }
         */
        _this.travelLocation = travel_location || travelLocation;
        /**
         * Relevant links related to the hacker
         * @type { string[] }
         */
        _this.links = links;
        /**
         * The number of hackathons the hacker has attended
         * @type { number }
         */
        _this.hackathonsAttended = parseNumber(hackathons_attended, hackathonsAttended);
        /**
         * The areas of tech that the hacker identifies as falling within (software, design or hardware)
         * @type { string[] }
         */
        _this.hackerKinds = parseArray(kind_of_hacker, hackerKinds);
        /**
         * What the hacker wants to gain from the event
         * @type { string }
         */
        _this.gainFromHackTheNorth = parseString(gainFromHackTheNorth, question_gain_from_htn);
        /**
         * The hardest challenge the hacker has faced
         * @type { string }
         */
        _this.hardestChallenge = parseString(question_hardest_challenge, hardestChallenge);
        /**
         * A stressful situation that the hacker encountered while working in a team
         * @type { string }
         */
        _this.stressfulTeamSituation = parseString(question_stressful_team, stressfulTeamSituation);
        /**
         * The gender of the hacker
         * @type { string }
         */
        _this.gender = parseStringOrNull(survey_gender, gender);
        /**
         * The ethnicities of the hacker
         * @type { string[] }
         */
        _this.ethnicities = parseArrayOrNull(survey_ethnicity, ethnicities);
        /**
         * The technologies that the hacker has used
         * @type { string[] }
         */
        _this.technologiesUsed = parseArrayOrNull(survey_tech_used, technologiesUsed);
        /**
         * The technology that the hacker is most excited about
         * @type { string }
         */
        _this.technologyMostExcitedAbout = parseStringOrNull(survey_tech_most_excited, technologyMostExcitedAbout);
        /**
         * True if the hacker's high school offered tech courses
         * @type { string }
         */
        _this.hadHighSchoolTechCourses = parseStringOrNull(survey_tech_course_hs, hadHighSchoolTechCourses);
        /**
         * The number of years the hacker has been building things related to their kind(s)
         * @type { number }
         */
        _this.yearsBuilding = parseNumber(survey_years_building, yearsBuilding);
        /**
         * True if the hacker has family in tech
         * @type { string }
         */
        _this.familyInTech = parseStringOrNull(survey_family_in_tech, familyInTech);
        /**
         * True if the hacker is the first in their family to pursue a post-secondary education
         * @type { string }
         */
        _this.firstInFamilyToPursuePostSecondary = parseStringOrNull(survey_family_in_higher_ed, firstInFamilyToPursuePostSecondary);
        /**
         * The color of the goose
         * @type { string }
         */
        _this.gooseColor = app_goose_colour || gooseColor;
        /**
         * The accessory that the goose has
         * @type { string }
         */
        _this.gooseAccessory = parseStringOrNull(app_goose_accessory, gooseAccessory);
        /**
         * @type { number }
         */
        _this.latitude = latitude;
        /**
         * @type { number }
         */
        _this.longitude = longitude;
        /**
         * @type { boolean }
         */
        _this.dataForOrganizationalPurposes = parseBoolean(consent_event_org, dataForOrganizationalPurposes);
        /**
         * @type { boolean }
         */
        _this.dataForReporting = parseBoolean(consent_aggregate_report, dataForReporting);
        /**
         * @type { boolean }
         */
        _this.dataForSponsors = parseBoolean(consent_partners_sponsors, dataForSponsors);
        /**
         * @type { boolean }
         */
        _this.consentsToPrivacyPolicy = parseBoolean(consent_privacy_policy, consentsToPrivacyPolicy);
        /**
         * @type { string }
         */
        _this.school = school;
        /**
         * @type { string }
         */
        _this.graduatingYear = graduating_year || graduatingYear;
        /**
         * @type { string }
         */
        _this.legalName = legal_name || legalName;
        /**
         * @type { string }
         */
        _this.dateOfBirth = date_of_birth || dateOfBirth;
        /**
         * @type { number }
         */
        _this.phoneNumber = phone_number || phoneNumber;
        /**
         * @type { string }
         */
        _this.city = city;
        /**
         * @type { string }
         */
        _this.province = province;
        /**
         * @type { string }
         */
        _this.country = country;
        /**
         * @type { string }
         */
        _this.code = code;
        /**
         * True if they are a Canadian citizen
         * @type { boolean }
         */
        _this.citizenship = citizenship;
        /**
         * @type { boolean }
         */
        _this.isOfLegalAge = parseBoolean(legal_age, isOfLegalAge);
        /**
         * The parental consent file
         * @type { number }
         */
        _this.parentalConsent = parental_consent || parentalConsent;
        /**
         * @type { boolean }
         */
        _this.mlhOptIn = parseBoolean(mlh_opt_in, mlhOptIn);
        /**
         * @type { string }
         */
        _this.emergencyName = emergency_name || emergencyName;
        /**
         * @type { string }
         */
        _this.emergencyEmail = emergency_email || emergencyEmail;
        /**
         * @type { string }
         */
        _this.emergencyPhone = emergency_phone || emergencyPhone;
        /**
         * @type { string }
         */
        _this.emergencyRelation = emergency_relation || emergencyRelation;
        /**
         * @type { string }
         */
        _this.dietaryConstraints = dietary_constraint || dietaryConstraints;
        /**
         * @type { string }
         */
        _this.healthConditions = health_condition || healthConditions;
        /**
         * @type { string }
         */
        _this.medication = medication;
        /**
         * @type { boolean }
         */
        _this.hasRestriction = parseBoolean(has_restriction, hasRestriction);
        /**
         * @type { boolean }
         */
        _this.hasHealthConcerns = parseBoolean(has_health_concerns, hasHealthConcerns);
        /**
         * @type { boolean }
         */
        _this.hasMedications = parseBoolean(has_medications, hasMedications);
        /**
         * @type { string }
         */
        _this.other = other;
        /**
         * Unisex or not? Why is it a boolean...
         * @type { boolean }
         */
        _this.shirtFit = parseBoolean(shirt_fit, shirtFit);
        /**
         * @type { "xs" | "s" | "m" | "l" | "xl" }
         */
        _this.shirtSize = shirt_size || shirtSize;
        /**
         * @type { string }
         */
        _this.shirtAccomodation = shirt_accomodation || shirtAccomodation;
        /**
         * @type { string }
         */
        _this.hardware = hardware;
        /**
         * @type { string[] }
         */
        _this.techTalkVotes = tech_talk_votes || techTalkVotes;
        /**
         * @type { string }
         */
        _this.projectIdea = project_idea || projectIdea;
        /**
         * @type { string[] }
         */
        _this.projectKeywords = project_keywords || projectKeywords;
        /**
         * @type { string }
         */
        _this.addressLine1 = address_line_1 || addressLine1;
        /**
         * @type { string }
         */
        _this.addressLine2 = address_line_2 || addressLine2;
        /**
         * @type { string }
         */
        _this.addressLine3 = address_line_3 || addressLine3;
        /**
         * @type { boolean }
         */
        _this.travelSourceCorrect = parseBoolean(travel_source_correct, travelSourceCorrect);
        /**
         * @type { boolean }
         */
        _this.immigrationAcknowledgement = parseBoolean(immigration_acknowledgement, immigrationAcknowledgement);
        /**
         * @type { boolean }
         */
        _this.requiresVisa = parseBoolean(requires_visa, requiresVisa);
        /**
         * @type { boolean }
         */
        _this.visaAcknowledgement = parseBoolean(visa_acknowledgement, visaAcknowledgement);
        /**
         * @type { string[] }
         */
        _this.receipts = receipts;
        /**
         * @type { string }
         */
        _this.fridayFlightNumber = friday_flight_number || fridayFlightNumber;
        /**
         * @type { string }
         */
        _this.fridayFlightAirline = friday_flight_airline || fridayFlightAirline;
        /**
         * @type { string }
         */
        _this.fridayFlightArrivalTime =
            friday_flight_arrival_time || fridayFlightArrivalTime;
        /**
         * @type { string }
         */
        _this.sundayFlightNumber = sunday_flight_number || sundayFlightNumber;
        /**
         * @type { string }
         */
        _this.sundayFlightAirline = sunday_flight_airline || sundayFlightAirline;
        /**
         * @type { string }
         */
        _this.sundayFlightDepartureTime =
            sunday_flight_departure_time || sundayFlightDepartureTime;
        /**
         * @type { string }
         */
        _this.flightPaymentCurrency =
            flight_payment_currency || flightPaymentCurrency;
        /**
         * @type { number }
         */
        _this.flightPaymentAmount = flight_payment_amount || flightPaymentAmount;
        /**
         * @type { boolean }
         */
        _this.shareEmailConsent = parseBoolean(share_email_consent, shareEmailConsent);
        /**
         * @type { "transit" | "driving" | "none" }
         */
        _this.transitOrDriving = transit_or_driving || transitOrDriving;
        /**
         * @type { string }
         */
        _this.visaTrackingNumber = visa_tracking_number || visaTrackingNumber;
        /**
         * @type { "cadCheque" | "usdCheque" | "wire" | "paypal" | "xoom" }
         */
        _this.reimbursementMethod = reimbursement_method || reimbursementMethod;
        /**
         * @type { string }
         */
        _this.reimbursementName = reimbursement_name || reimbursementName;
        /**
         * @type { string }
         */
        _this.reimbursementAddressLine1 =
            reimbursement_address_line_1 || reimbursementAddressLine1;
        /**
         * @type { string }
         */
        _this.reimbursementAddressLine2 =
            reimbursement_address_line_2 || reimbursementAddressLine2;
        /**
         * @type { string }
         */
        _this.reimbursementAddressLine3 =
            reimbursement_address_line_3 || reimbursementAddressLine3;
        /**
         * @type { string }
         */
        _this.reimbursementWireCurrency =
            reimbursement_wire_currency || reimbursementWireCurrency;
        /**
         * @type { string }
         */
        _this.reimbursementWireBankName =
            reimbursement_wire_bank_name || reimbursementWireBankName;
        /**
         * @type { string }
         */
        _this.reimbursementWireBankAddressLine1 =
            reimbursement_wire_bank_address_line_1 ||
                reimbursementWireBankAddressLine1;
        /**
         * @type { string }
         */
        _this.reimbursementWireBankAddressLine2 =
            reimbursement_wire_bank_address_line_2 ||
                reimbursementWireBankAddressLine2;
        /**
         * @type { string }
         */
        _this.reimbursementWireBankAddressLine3 =
            reimbursement_wire_bank_address_line_3 ||
                reimbursementWireBankAddressLine3;
        /**
         * @type { string }
         */
        _this.reimbursementWireBranchNumber =
            reimbursement_wire_branch_number || reimbursementWireBranchNumber;
        /**
         * @type { string }
         */
        _this.reimbursementWireInstitutionNumber =
            reimbursement_wire_institution_number ||
                reimbursementWireInstitutionNumber;
        /**
         * @type { string }
         */
        _this.reimbursementWireSwiftCode =
            reimbursement_wire_swift_code || reimbursementWireSwiftCode;
        /**
         * @type { string }
         */
        _this.reimbursementWireIbanNumber =
            reimbursement_wire_iban_number || reimbursementWireIbanNumber;
        /**
         * @type { string }
         */
        _this.reimbursementWireRoutingNumber =
            reimbursement_wire_routing_number || reimbursementWireRoutingNumber;
        /**
         * @type { string }
         */
        _this.reimbursementWireAccountNumber =
            reimbursement_wire_account_number || reimbursementWireAccountNumber;
        /**
         * @type { string }
         */
        _this.reimbursementWireOther =
            reimbursement_wire_other || reimbursementWireOther;
        /**
         * @type { string }
         */
        _this.reimbursementVisaNumber =
            reimbursement_visa_number || reimbursementVisaNumber;
        /**
         * @type { string }
         */
        _this.reimbursementPaypalEmail =
            reimbursement_paypal_email || reimbursementPaypalEmail;
        /**
         * @type { string }
         */
        _this.reimbursementXoomEmail =
            reimbursement_xoom_email || reimbursementXoomEmail;
        /**
         * @type { boolean }
         */
        _this.reimbursementAcknowledgement = parseBoolean(reimbursement_acknowledgement, reimbursementAcknowledgement);
        /**
         * @type { boolean }
         */
        _this.termsAcknowledgement = parseBoolean(terms_acknowledgement, termsAcknowledgement);
        /**
         * @type { string }
         */
        _this.travelMethod = travel_method || travelMethod;
        /**
         * @type { string }
         */
        _this.flightAndBusLocation = flight_and_bus_location || flightAndBusLocation;
        /**
         * @type { string }
         */
        _this.busRoute = bus_route || busRoute;
        /**
         * @type { string }
         */
        _this.flightReimbursement = flight_reimbursement || flightReimbursement;
        /**
         * @type { string }
         */
        _this.departureAirport = departure_airport || departureAirport;
        /**
         * @type { string }
         */
        _this.arrivalAirport = arrival_airport || arrivalAirport;
        /**
         * @type { string }
         */
        _this.transitOrDrivingReimbursementDeadline =
            transit_or_driving_reimbursement_deadline ||
                transitOrDrivingReimbursementDeadline;
        /**
         * @type { boolean }
         */
        _this.seekingInternship = parseBoolean(seeking_internship, seekingInternship);
        /**
         * @type { boolean }
         */
        _this.seekingFulltime = parseBoolean(seeking_fulltime, seekingFulltime);
        /**
         * @type { boolean }
         */
        _this.hasVisa = parseBoolean(has_visa, hasVisa);
        /**
         * The file ID of a hacker's resume
         * @type { number }
         */
        _this.resume = resume;
        /**
         * @type { string[] }
         */
        _this.coffeeChatRanking = coffee_chat_ranking || coffeeChatRanking;
        /**
         * @type { boolean }
         */
        _this.coffeeChatOptIn = parseBoolean(coffee_chat_opt_in, coffeeChatOptIn);
        /**
         * @type { string[] }
         */
        _this.interestedCompanies = interested_companies || interestedCompanies;
        /**
         * @type { number }
         */
        _this.stageId = stage_id || stageId;
        /**
         * @type { string }
         */
        _this.guardianName = guardian_name || guardianName;
        /**
         * @type { string }
         */
        _this.guardianEmail = guardian_email || guardianEmail;
        /**
         * @type { string }
         */
        _this.rsvpDeadline = rsvp_deadline || rsvpDeadline;
        return _this;
    }
    /**
     * Gets a hacker's application
     * @param event - The event the application is for
     * @param event.slug
     * @param [claim] - The claim to fetch (defaults to the authenticated user's own)
     * @returns The hacker's application
     */
    Application.fetch = function (_a, _b, token) {
        var slug = _a.slug;
        var id = (_b === void 0 ? { id: "me" } : _b).id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/applications/" + id,
            method: "GET",
            token: token
        }).then(function (data) { return new Application(data); });
    };
    /**
     * Starts an application
     * @param event - The event the application is for
     * @param event.slug
     * @param update - The application to create
     * @param token
     * @returns
     */
    Application.create = function (_a, application, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/applications",
            method: "POST",
            body: application.toHackerAPIFormat(),
            token: token
        }).then(function (data) { return new Application(data); });
    };
    /**
     * Updates an application
     * @param event - The event the application is for
     * @param event.slug
     * @param application - The application to update
     * @param token
     * @returns
     */
    Application.update = function (_a, application, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/applications/" + (application.id || "me"),
            method: "PUT",
            token: token,
            body: application.toHackerAPIFormat()
        }).then(function (data) { return new Application(data); });
    };
    /**
     * Submits an application
     * @param event
     * @param event.slug
     * @param [claim]
     * @param [claim.id]
     * @param [token]
     * @returns
     */
    Application.submit = function (_a, _b, token) {
        var slug = _a.slug;
        var id = (_b === void 0 ? { id: "me" } : _b).id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/applications/" + id + "/submit",
            method: "POST",
            body: {},
            token: token
        });
    };
    return Application;
}(Base));
export default Application;
//# sourceMappingURL=application.js.map